const runtimeEnvironment =
  typeof window !== 'undefined' && window._env && typeof window._env === 'object'
    ? window._env
    : {};

export const APPLICABLE_HOOD_IDS = String(runtimeEnvironment.APPLICABLE_HOODS || '')
  .split(',')
  .map((hoodId) => hoodId.trim())
  .filter(Boolean);

export const isApplicableHood = (hoodId) =>
  Boolean(hoodId) && APPLICABLE_HOOD_IDS.includes(String(hoodId));

export const filterApplicableHoods = (hoods = []) =>
  (Array.isArray(hoods) ? hoods : []).filter((hood) => isApplicableHood(hood && hood.id));

const getEntityKey = (entity) => String((entity && (entity.id || entity.slug)) || '');

export const mergeApplicableHoodCatalogues = (catalogueEntries = []) => {
  const categoryMap = new Map();

  catalogueEntries.forEach(({ hoodId, catalogue }) => {
    if (!isApplicableHood(hoodId)) return;

    const categories = Array.isArray(catalogue && catalogue.categories)
      ? catalogue.categories
      : [];
    categories.forEach((category) => {
      const categoryKey = getEntityKey(category);
      if (!categoryKey) return;

      if (!categoryMap.has(categoryKey)) {
        categoryMap.set(categoryKey, { ...category, subcategoryList: [] });
      }
      const mergedCategory = categoryMap.get(categoryKey);
      const subcategoryMap = new Map(
        mergedCategory.subcategoryList.map((subcategory) => [
          getEntityKey(subcategory),
          subcategory,
        ]),
      );

      const subcategories = Array.isArray(category.subcategoryList)
        ? category.subcategoryList
        : [];
      subcategories.forEach((subcategory) => {
        const subcategoryKey = getEntityKey(subcategory);
        if (!subcategoryKey) return;

        if (!subcategoryMap.has(subcategoryKey)) {
          const mergedSubcategory = { ...subcategory, hoodItems: [] };
          subcategoryMap.set(subcategoryKey, mergedSubcategory);
          mergedCategory.subcategoryList.push(mergedSubcategory);
        }
        const mergedSubcategory = subcategoryMap.get(subcategoryKey);
        const existingItemIds = new Set(
          mergedSubcategory.hoodItems.map((item) => getEntityKey(item)).filter(Boolean),
        );
        const hoodItems = Array.isArray(subcategory.hoodItems) ? subcategory.hoodItems : [];
        hoodItems.forEach((item) => {
          const itemKey = getEntityKey(item);
          if (!itemKey) return;
          if (existingItemIds.has(itemKey)) {
            const existingItem = mergedSubcategory.hoodItems.find(
              (mergedItem) => getEntityKey(mergedItem) === itemKey,
            );
            existingItem.applicableHoodIds = [
              ...new Set([...(existingItem.applicableHoodIds || []), hoodId]),
            ];
            return;
          }
          mergedSubcategory.hoodItems.push({
            ...item,
            hoodId: item.hoodId || hoodId,
            applicableHoodIds: [hoodId],
          });
          existingItemIds.add(itemKey);
        });
      });
    });
  });

  return { categories: Array.from(categoryMap.values()) };
};

if (process.env.NODE_ENV !== 'production' && APPLICABLE_HOOD_IDS.length === 0) {
  // eslint-disable-next-line no-console
  console.warn('[Meroha] APPLICABLE_HOODS is empty; Hood item APIs are disabled.');
}

